import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { Router } from '@angular/router';
import { CheckBoxMultiNivelEstructura } from '../checkbox-multinivel/checkbox-multinivel.component';


export interface Familias {
  CodigoFamilia: string;
  ApellidoFamilia: string;
  CantEst: string;
  CodigoRegistro: string;
}




@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss'],
})
export class TablaComponent implements OnInit {
  displayedColumns: string[] = ['select', 'CodigoFamilia', 'ApellidoFamilia', 'CodigoRegistro',
  'CantEst', 'CantUsuarios'];
  dataSource: MatTableDataSource<Familias>;
  selection = new SelectionModel<Familias>(true, []);
  Datos = []
  fest = ""
  valval = "todos"

  carg=false;

  @Input() filtro = "todas";

  Cursos = []
  CursosMultinivel: Array<CheckBoxMultiNivelEstructura> = [];
  Destinos = []
  Destinos2 = []

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private conexion: ConexionService, public utilidades: UtilidadesService, private router: Router) {
    this.dataSource = new MatTableDataSource([]);
  }

  FiltroPorCantEst(val) {
    if(this.carg==false) return 0;
     let c = JSON.stringify(this.Datos)
    let cj: any[] = JSON.parse(c)
    let f = []
    if (val != "todos") {
      if (val == "Con") {
        // f = cj.filter(familia => familia.CantEst > 0)
        for(let i of cj){
          if(i.CantEst>0){
            f.push(i)
          }
        }
      } else {
        f = cj.filter(familia => familia.CantEst == 0)
      }
    } else {
      f = cj

      // ksjgkdfjgkfd kdfg khdfjk gdjf gh
    }

    this.fest = JSON.stringify(f)
 
    this.dataSource = new MatTableDataSource(f);
    this.ngAfterViewInit()
    this.valval = val

  }

  ngOnInit() {
   
    this.getFamilias()
    this.getCursosDestinos()
  }


  getCursosDestinos() {
    // this.utilidades.Loading("Cargando las categorias")
    this.conexion.getCursosDestinos().subscribe((resp) => {
      // this.utilidades.CerrarLoading()
      if (resp.Respuesta == "Exito") {
        this.Cursos = resp.Datos;

        for (let i in this.Cursos) {
          this.CursosMultinivel.push({
            name: this.Cursos[i].Descripcion, completed: false,
            subtasks: []
          })
          for (let j of this.Cursos[i].Secciones) {
            this.CursosMultinivel[i].subtasks.push({ name: j.Curso + " " + j.Seccion, completed: true, value: j.Id })
          }
        }

        this.utilidades.Depuracion(this.CursosMultinivel, "console", "")
      }
    }, (err) => {
      // this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  FormatoCodigo(codigo: string): string {
    if(!codigo) return '';
    codigo = String(codigo).toUpperCase()
    codigo = codigo.substring(0, 4) + "-" + codigo.substring(4, 8)
    return codigo
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


  getFamilias() {
    setTimeout(() => {
      this.carg=true
    }, 3000);
    this.carg=false
    this.utilidades.Loading("Cargando familias")
    this.conexion.getFamilias(this.filtro).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      if (resp.Respuesta == "Exito") {
        this.Datos = resp.Datos
        this.utilidades.Depuracion(resp, "console", "")
        this.dataSource = new MatTableDataSource(resp.Datos);
        this.ngAfterViewInit()
        this.FiltroPorCantEst(this.valval)
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  desabilitatSiAlgunaFamiliaNoTieneCodigoDeRegistro(){
    for(let i of this.selection.selected){
      if(!i.CodigoRegistro){
        return true;
      }
    }
    return false;
  }

  CambiarEstado(estado) {

    if (!this.selection.selected) {
      this.utilidades.Alerta("No hay ninguna familia seleccionada")
      return 0;
    }

    let datos = { Familias: this.selection.selected, Estado: estado }

    this.conexion.CambiarEstadoFamilias(datos).subscribe((resp) => {
      this.utilidades.Alerta(resp.Mensaje)
    }, (err) => {
      if (err.error.Respuesta == "Advertencia") {
        this.utilidades.Alerta(JSON.stringify(datos), "Aceptar", err.error.Mensaje)
      } else {
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      }

      this.utilidades.ValidarUser(err)
    })
  }


  GenerarCodigo(validar_vencimiento = true) {

    if (!this.selection.selected) {
      this.utilidades.Alerta("No hay ninguna familia seleccionada")
      return 0;
    }

    let datos = { Familias: this.selection.selected, ValidarVencimiento: validar_vencimiento }

    // alert(JSON.stringify(datos))
    this.utilidades.Loading(130000)
    this.conexion.GenerarCodigoFamilias(datos).subscribe((resp) => {
      this.utilidades.Depuracion(resp, "console", "")
      // this.utilidades.Alerta(resp.Mensaje)
      this.utilidades.CerrarLoading()

      localStorage.setItem("FamiliasImprecion", JSON.stringify(resp.Generados))
      this.utilidades.Depuracion(resp.Generados, "console", "")
      this.router.navigate(['/documento-cod-familia'])

    }, (err) => {
      this.utilidades.CerrarLoading()
      if (err.error.Respuesta == "Advertencia") {
        if (err.error.Codigo == "GCF001") {
          if (confirm(err.error.Mensaje)) {
            this.GenerarCodigo(false)
          }
        } else {
          this.utilidades.Alerta(JSON.stringify(datos), "Aceptar", err.error.Mensaje)
        }
      } else {
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      }

      this.utilidades.ValidarUser(err)
    })
  }

  ImprimirCodigo() {

    if (!this.selection.selected) {
      this.utilidades.Alerta("No hay ninguna familia seleccionada")
      return 0;
    }

    let data = JSON.parse(JSON.stringify(this.selection.selected))
    for(let i in data){
      data[i].Codigo = data[i].CodigoRegistro
    }

      localStorage.setItem("FamiliasImprecion", JSON.stringify(data))
      this.router.navigate(['/documento-cod-familia'])

  
  }

  CC() {
    this.utilidades.Depuracion(this.Destinos2, "console", "")
    let c = this.fest
    let cj: any[] = JSON.parse(c)
    let f = []
   
    f = cj.filter(familia => this.EstaSeccion(String(familia.Secciones).split(", ")))

    this.dataSource = new MatTableDataSource(f);
    this.ngAfterViewInit()
  }


  EstaSeccion(secciones){
    for(let i of secciones){
      for(let j of this.Destinos2){
        if(Number(i)==Number(j)){
          return true
        }
      }
    }

    return false
  }
}

